var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.modelName,"actions":_vm.actions,"modelColumnDefs":_vm.modelColumnDefs,"externalFilter":_vm.externalFilter,"showCreateBtn":false,"showDeleteBtn":false,"readOnly":""}}),_c('anchorageoperations-modals',{attrs:{"modelName":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }